import { render } from "./icon-open-card-g.vue?vue&type=template&id=f7b6d5f6"
const script = {}

import exportComponent from "D:\\project\\haocai\\h5\\kousai-group\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__